import Api from "../apiService";

class FleetRepairsApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/fleet/repairs`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, id) {
    return Api.getRequest(
      `companies/${companyId}/fleet/repairs/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/fleet/repairs`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/fleet/repairs/${id}`,
      data,
      Api.authHeaders()
    );
  }

  changeStatus(companyId, id, data = {}) {
    return Api.patchRequest(
      `companies/${companyId}/fleet/repairs/${id}/change_status`,
      data,
      Api.authHeaders()
    );
  }

  archive(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/fleet/repairs/${id}/archive`,
      {},
      Api.authHeaders()
    );
  }

  restore(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/fleet/repairs/${id}/restore`,
      {},
      Api.authHeaders()
    );
  }

  attachExpense(companyId, id, expenseId) {
    return Api.postRequest(
      `companies/${companyId}/fleet/repairs/${id}/attach_expense`,
      { expense_id: expenseId },
      Api.authHeaders()
    );
  }

  confirmInspection(companyId, id, data) {
    return Api.postRequest(
      `companies/${companyId}/fleet/repairs/${id}/confirm_inspection`,
      data,
      Api.authHeaders()
    );
  }
}

export default new FleetRepairsApi();
